<template>
    <button v-if="available" type="button" class="ai-launcher" :aria-expanded="open"
        aria-controls="global-ai-assistant" title="Abrir assistente de IA" @click="$emit('toggle')">
        <span class="ai-launcher__icon"><i class="bi-stars" aria-hidden="true"></i></span>
        <span class="ai-launcher__label"><small>THALAMUS AI</small>Assistente</span>
    </button>
</template>

<script>
export default {
    name: 'AssistantLauncher',
    emits: ['toggle'],
    props: {
        available: Boolean,
        open: Boolean,
    },
}
</script>

<style scoped>
.ai-launcher {
    position: fixed;
    right: 1.5rem;
    bottom: 1.5rem;
    z-index: 1090;
    display: inline-flex;
    align-items: center;
    gap: 0.65rem;
    padding: 0.48rem 0.85rem 0.48rem 0.48rem;
    border: 1px solid rgba(255, 255, 255, 0.35);
    border-radius: 999px;
    box-shadow: 0 12px 32px rgba(49, 46, 129, 0.3);
    background: linear-gradient(135deg, #312e81, #4f46e5 55%, #7e22ce);
    color: #fff;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
}
.ai-launcher:hover { transform: translateY(-2px); box-shadow: 0 16px 38px rgba(49, 46, 129, 0.38); }
.ai-launcher__icon { display: grid; width: 2.35rem; height: 2.35rem; place-items: center; border-radius: 50%; background: rgba(255, 255, 255, 0.16); font-size: 1rem; }
.ai-launcher__label { display: flex; flex-direction: column; align-items: flex-start; line-height: 1.05; }
.ai-launcher__label small { margin-bottom: 0.18rem; opacity: 0.7; font-size: 0.52rem; letter-spacing: 0.09em; }
</style>

<style>
body:has(.botao-flutuante) .ai-launcher {
    right: calc(24px + 56px + 12px);
    bottom: 24px;
}

@media screen and (max-width: 970px) {
    body:has(.botao-flutuante) .ai-launcher {
        right: calc(16px + 48px + 12px);
        bottom: 16px;
    }
}
</style>
